import { createSelector } from 'reselect'


const getQueueState = state => state.links
export const getQueueFilter = state => getQueueState(state).filter
export const getQueueItems = state => getQueueState(state).list
export const getQueueSorting = state => getQueueState(state).sort
export const isLoadingLinks = state => getQueueState(state).loading

export const getVisibleItems = createSelector(
  getQueueItems,
  getQueueFilter,
  (items, filter) => items.filter(item => item.url.indexOf(filter.toLowerCase()) > -1)
)

export const getSortedVisibleItems = createSelector(
  getVisibleItems,
  getQueueSorting,
  (items, sort) => {
    if (sort.get('sortBy') === 'default') {
      return items
    }
    else {
      return items
        .sortBy(link => link.get(sort.get('sortBy')))
        .update(list => sort.get('sortDirection') === 'DESC' ? list.reverse() : list)
    }
  },
)

export const getVisibleItemsCount = createSelector(
  getVisibleItems,
  items => items.size,
)

export const getItemsCount = createSelector(
  getQueueItems,
  items => items.size,
)

export const getProcessedItems = createSelector(
  getQueueItems,
  items => items.filter(item => item.statusCode !== null),
)

export const getProcessedItemsCount = createSelector(
  getProcessedItems,
  items => items.size,
)



// WEBPACK FOOTER //
// ./src/modules/links/selectors.js